'use client';

import { useState } from 'react';

import { Container } from '@/components/container';
import { SectionDescription } from '@/components/section-description/section-description';
import { Accordion } from '@/components/ui/accordion';

import { DevelopmentAccordionItem } from './components/development-accordion-item/development-accordion-item';
import { DEVELOPMENT_ROUTINES } from './constants';

const DEVELOPMENT_ITEM_NAME = 'dev-item';

export const DevelopmentSection = () => {
    const [selectedItem, setSelectedItem] = useState(
        `${DEVELOPMENT_ITEM_NAME}-0`,
    );

    return (
        <Container
            as="section"
            verticalSpacing
            className={`
              flex flex-col

              lg:flex-row lg:gap-20
            `}
        >
            <div className={`flex flex-1 flex-col justify-center`}>
                <SectionDescription
                    title="DEVELOPMENT"
                    header="Exploring knowledge"
                    variant="aside"
                >
                    <p>
                        At SwingDev, a passion for learning and sharing
                        knowledge is at the heart of what we do. We&apos;re
                        trying to create opportunities for our team to grow
                        together, exchange insights, and develop new skills.
                    </p>
                </SectionDescription>
            </div>

            <div
                className={`
                  flex-1

                  xxl:min-w-[600px]
                `}
            >
                <Accordion
                    collapsible
                    type="single"
                    className="flex flex-col gap-4"
                    value={selectedItem}
                    onValueChange={setSelectedItem}
                >
                    {DEVELOPMENT_ROUTINES.map(
                        ({ description, id, title }, index) => (
                            <DevelopmentAccordionItem
                                key={id}
                                title={title}
                                id={`${DEVELOPMENT_ITEM_NAME}-${index}`}
                                isSelected={
                                    selectedItem ===
                                    `${DEVELOPMENT_ITEM_NAME}-${index}`
                                }
                            >
                                <ul>
                                    <p className={'text-xl font-medium'}>
                                        {description}
                                    </p>
                                </ul>
                            </DevelopmentAccordionItem>
                        ),
                    )}
                </Accordion>
            </div>
        </Container>
    );
};
